/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import UniversalRouter from 'universal-router'
import routes from './routes'

export default function(existingRoutes) {

  const enabledRoutes = existingRoutes.length > 0 ? {
    ...routes,
    children: existingRoutes.map((r) => {
      const enabledRoute = routes.children.filter(rc => rc.path === r.path && r.active)
      if (enabledRoute[0]) {
        return {
          ...enabledRoute[0]
        }
      }
      return null
    }).filter((r) => r !== null)
  } : { ...routes }

  // console.log('routes', routes)
  // console.log('enabledRoutes', enabledRoutes)

  return new UniversalRouter(enabledRoutes, {
    resolveRoute(context, params) {
      if (typeof context.route.load === 'function') {
        return context.route.load().then(action => action.default(context, params))
      }
      if (typeof context.route.action === 'function') {
        return context.route.action(context, params)
      }
      return undefined
    },
  })
}